import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";
import { WithAnimationContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/WithAnimationContainer";

const { carbon } = colorsPalettes;

export const BodyContainer = styled.div`
    padding: 16px 12px 24px 12px;
`;

export const TextFieldContainer = styled.div`
    min-height: 78px;
`;

export const TextFieldTitle = styled.div`
    ${setFontVariant("body1", carbon[400])};
    margin-bottom: 16px;
`;
export const SharingDisclaimer = styled.span`
    ${setFontVariant("caption", carbon[400])};
    margin-top: 4px;
`;

export const Container = styled(WithAnimationContainer)`
    display: flex;
    flex-direction: column;
    padding: 12px 12px 16px 12px;
`;

export const Title = styled.span`
    ${setFontVariant("h5", carbon[500])};
    padding: 8px 12px 20px 12px;
`;
